import { Injectable, Inject } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { AuthConfig } from '..';
import { getCookie, deleteCookie } from '../helpers/cookie-utils';

@Injectable({
  providedIn: 'root',
})
export class OidcLoginGuard implements CanActivate {
  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject('config') private config: AuthConfig,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // When 'token' exists, redirect user to 'admin' page
    if (window.sessionStorage.getItem('token')) {
      this.router.navigate(['/', 'admin']);
      return false;
    }

    // When 'light_token' exists, get token from OIDC server and redirect user to 'admin' page
    // because 'token' with rbac is too big to be stored in cookie
    // we need to exchange 'light_token' with JWT token with rbac permissions
    const cookie_name = 'light_token';
    const light_token = getCookie(cookie_name);
    if (light_token) {
      deleteCookie(cookie_name);

      const oidc_token_url = this.config.oidc_token_url;
      const responseType = 'text';
      this.http
        .get(`${oidc_token_url}`, {
          responseType,
          headers: {
            Authorization: `Bearer ${light_token}`,
          },
        })
        .subscribe((response: string) => {
          window.sessionStorage.setItem('token', response);
          this.router.navigate(['/', 'admin']);
          return false;
        });

      console.warn(
        `Failed to get token with light_token=${light_token}; redirecting to login page`,
      );
    }

    // When both 'token' session not exist and 'light_token' does not exist,
    // allow user to access 'oidc-login' page
    return true;
  }
}
